var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      style: _vm.css,
      attrs: {
        filterable: "",
        remote: "",
        "value-key": "id",
        "remote-method": _vm.searchTicket,
        placeholder: "输入工单标题或编号搜索",
        clearable: ""
      },
      on: { change: _vm.onChange },
      model: {
        value: _vm.ticket,
        callback: function($$v) {
          _vm.ticket = $$v
        },
        expression: "ticket"
      }
    },
    _vm._l(_vm.ticketList, function(item) {
      return _c("el-option", {
        key: item.orderId,
        attrs: {
          label: item.orderTitle + "(" + item.orderId + ")",
          value: item
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fa8b6692", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8b6692","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketSearch.vue
// module id = 818
// module chunks = 75